import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { useSearchParams } from 'react-router-dom';
import { CampanhaParameters } from '../../../../infra/routes/campanhaRoutes';
import { Button } from 'base/src/components/Button';
import { useEffect, useState } from 'react';
import PagedAprovar from '../../../pagarPedido/components/pagedAprovar/pagedAprovar';
import { GetAuthRoute } from 'domain/types/sistema/sistemaList';
import { Redirect } from 'base/src/utils/routeUtil';
import { GetCarteiraUsuario } from 'domain/store/_carteira/carteiraBase/actions/carteiraBaseAction';
import { ResetResgatesCheckout, ResgatesCheckout } from 'domain/store/_carteira/campanhaPedidoResgate/actions/campanhaPedidoResgateAction';
import { RootStateCampanha } from '../../../../store/campanhaReducer';
import { Modal, ModalContent } from 'base/src/components/Modal';
import ModalGerarLote from '../../../pagarPedido/components/ModalGerarLote/ModalGerarLote';
import * as S from '../../../pagarPedido/pagarPedidoStyle';

const connector = connectUtil(
  (state: RootStateCampanha) => ({
    usuarioSistemaPerfil: state.UsuarioSistemaPerfilReducer.usuarioSistemaPerfil,
    TaxaPagamento: state.CarteiraBaseReducer.CarteiraBase.TaxaPagamento,
    Pagar: state.CampanhaPedidoResgateReducer.formData,
    CampanhaPedidoResgate: state.CampanhaPedidoResgateReducer.CampanhaPedidoResgateByCampanha,
  }),
  { GetCarteiraUsuario, ResgatesCheckout, ResetResgatesCheckout }
);

export interface PagarPedidoContentProps extends PropsFromRedux<typeof connector> { }

function PagarPedidoContent(props: PagarPedidoContentProps) {
  const [searchParams] = useSearchParams();
  const campanhaId = searchParams.get(CampanhaParameters.campanhaId);

  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    props.ResetResgatesCheckout();
  }, []);

  useEffect(() => {
    props.GetCarteiraUsuario(() => { Redirect(GetAuthRoute()) });
  }, []);

  function handleOpenModal() {
    setIsModalOpen(true);
  }

  function handleCloseModal() {
    setIsModalOpen(false);
  }

  return (
    campanhaId && (
      <>
        <Modal open={isModalOpen} onOpenChange={setIsModalOpen}>
          <ModalContent contentStyle={{ width: '80vw', minWidth: '400px', maxWidth: '1000px' }}>
            <h2>Gerar Novo Lote de Pagamentos</h2>
            <ModalGerarLote onClose={handleCloseModal} />
          </ModalContent>
        </Modal>

        <S.TableContainer>
          <PagedAprovar
            openModalLote={<Button size='md' onClick={handleOpenModal}>Novo Lote</Button>}
            take={5}
            campanhaId={Number(campanhaId)}
          />
        </S.TableContainer>
      </>
    )
  );
}

export default connector(PagarPedidoContent);